import React from 'react';
import BaseFaq from 'components/Faq';

export default function Faq() {
  return (
    <BaseFaq
      items={[
        {
          question: 'What is meant by graphical abstract?',
          answer:
            "Graphical abstract is an infographic that represents the paper's abstract visually, making it easier to understand by the audience.",
        },
        {
          question: 'How do you write a graphical abstract?',
          answer:
            "To write a graphical abstract you'll need your plain-text abstract, beautiful science figures, basic design elements, and a workspace to put all this together. Mind the Graph is a tool with a friendly drag-and-drop interface where you can easily create graphical abstracts, presentations and more.",
        },
        {
          question: 'Is a graphical abstract required?',
          answer:
            "It depends on the journal you choose to publish. Given its rising popularity, many publishers are already requiring graphical abstracts as mandatory in the research paper's publishing process. SO, be sure of every information before submitting it.",
        },
        {
          question: 'What is graphical abstract in IEEE?',
          answer:
            "In the Institute of Electrical and Electronics Engineers, a graphical abstract is an infographic that represents the paper's abstract visually.",
        },
      ]}
    />
  );
}
